import { config } from "../config";

export const isLowQualityBitrate = (currentBitrate) => currentBitrate <= config.MIN_BITRATE_QUALITY;

/** See available errors on the official documentation:
 * https://aws.github.io/amazon-ivs-player-docs/1.5.0/web/interfaces/playererror.html
 */
export const isStreamlabsError = (error) =>
  config.AWS_STREAM_DISPLAY_ERROR_CODES.indexOf(error.type) >= 0;
